/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListInvoices200ResponseItemsInner } from './ListInvoices200ResponseItemsInner';
import {
    ListInvoices200ResponseItemsInnerFromJSON,
    ListInvoices200ResponseItemsInnerFromJSONTyped,
    ListInvoices200ResponseItemsInnerToJSON,
    ListInvoices200ResponseItemsInnerToJSONTyped,
} from './ListInvoices200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListInvoices200Response
 */
export interface ListInvoices200Response {
    /**
     * 
     * @type {Array<ListInvoices200ResponseItemsInner>}
     * @memberof ListInvoices200Response
     */
    items: Array<ListInvoices200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof ListInvoices200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListInvoices200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ListInvoices200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the ListInvoices200Response interface.
 */
export function instanceOfListInvoices200Response(value: object): value is ListInvoices200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function ListInvoices200ResponseFromJSON(json: any): ListInvoices200Response {
    return ListInvoices200ResponseFromJSONTyped(json, false);
}

export function ListInvoices200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListInvoices200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ListInvoices200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function ListInvoices200ResponseToJSON(json: any): ListInvoices200Response {
    return ListInvoices200ResponseToJSONTyped(json, false);
}

export function ListInvoices200ResponseToJSONTyped(value?: ListInvoices200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ListInvoices200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

